import { safeLocalStorage } from 'utils/storage';

export const RELAY_REQUIRED_KEY = 'ice:relayRequiredUntil';
export const RELAY_REQUIRED_TTL_MS = 24 * 60 * 60_000;

// Both "Rejoin" buttons reload the page, so a session-scoped flag would make the user
// pay the first-join stall again; the TTL bounds staleness after a network change.
export const relayRequiredUntil = (now = Date.now()): number | null => {
  const until = Number(safeLocalStorage.getItem(RELAY_REQUIRED_KEY));

  return Number.isFinite(until) && until > now ? until : null;
};

export const isRelayRequiredRemembered = (now = Date.now()) => relayRequiredUntil(now) !== null;

export const rememberRelayRequired = (now = Date.now()) => {
  safeLocalStorage.setItem(RELAY_REQUIRED_KEY, String(now + RELAY_REQUIRED_TTL_MS));
};
